/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Product_Codes_InvalidInputs */

const en_error_product_codes_invalid = /** @type {(inputs: Error_Product_Codes_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tomorrow's codes cannot be these.`)
};

/**
* | output |
* | --- |
* | "Tomorrow's codes cannot be these." |
*
* @param {Error_Product_Codes_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_product_codes_invalid = /** @type {((inputs?: Error_Product_Codes_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Product_Codes_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_product_codes_invalid(inputs)
});